import { render, staticRenderFns } from "./dashboard-status.vue?vue&type=template&id=6792949b"
import script from "./dashboard-status.vue?vue&type=script&lang=js"
export * from "./dashboard-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports